export default function Home() {
  return (
    // This is the template home page, please edit from this page
    <div className="flex flex-col items-center pt-8">
      <h1 className="text-xl font-bold">Please switch pages in the dropdown menu above 👆🏻</h1>
    </div>
  );
}